import { Link } from 'react-router-dom';
import { brand, stats } from '@/mocks/gossip';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20lively%20celebration%20scene%20abstract%20with%20warm%20coral%20orange%20amber%20and%20mint%20green%20glowing%20shapes%2C%20confetti%20and%20bokeh%20lights%2C%20soft%20grain%20editorial%20poster%20illustration%2C%20rich%20contrast%2C%20no%20text&width=1600&height=900&seq=gt-hero-party&orientation=landscape"
          alt="瓜田福利社 福利吃瓜互动社区氛围图"
          title="福利吃瓜 互动社区"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/85"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 pb-14 md:pb-20">
        <div className="max-w-3xl animate-float-in">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 text-xs md:text-sm mb-5">
            <i className="ri-fire-line"></i>
            每日更新 · 转发抽奖 · 打卡 · 投票
          </span>
          <h1 className="font-heading text-4xl md:text-6xl text-background-50 leading-tight">
            瓜田福利社：福利吃瓜转发抽奖社区
          </h1>
          <p className="mt-5 text-base md:text-lg text-background-50/85 leading-relaxed max-w-2xl">
            把每天值得聊的热点话题聚在一起，再配上福利吃瓜转发、抽奖、评论区互动、打卡、粉丝投票等玩法。边吃瓜边互动，赢取专属福利，和同好一起聊热点、玩转评论区。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-compass-3-line"></i>
              逛今日吃瓜热榜
            </Link>
            <Link
              to="/activities"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium whitespace-nowrap hover:bg-accent-400 transition-colors"
            >
              <i className="ri-gift-line"></i>
              参与互动玩法
            </Link>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {stats.map((item) => (
            <div
              key={item.id}
              className="px-4 py-4 md:px-5 md:py-5 rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur-sm"
            >
              <p className="font-heading text-2xl md:text-3xl text-background-50">
                {item.value}
                <span className="text-sm md:text-base ml-1 text-background-50/70">{item.unit}</span>
              </p>
              <p className="mt-1 text-xs md:text-sm text-background-50/70">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}